import { DirectoryPage } from 'components/Directory/DirectoryPage'
import { RaineSquareDirectoryHeader } from 'components/Directory/RaineSquare/RaineSquareDirectoryHeader'
import RaineSquareLogo from 'components/Icons/RaineSquareLogo'
import { NextPage } from 'next'
import React from 'react'

const RaineSquareDirectory: NextPage = () => {
  return (
    <DirectoryPage
      vcPrefix="rs"
      title="Raine Square - Mr Yum"
      logo={<RaineSquareLogo height={54} />}
      headerImageUrl="/static/rainesquare/header.jpg"
      selectPlaceholder="Select your level"
      allCollectionsLabel="All Levels"
    >
      <RaineSquareDirectoryHeader />
    </DirectoryPage>
  )
}

export default RaineSquareDirectory
